import React from 'react';
import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import config from 'config';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function PoweredBy() {
  const classes = useStyles();
  const { t } = useTranslation('labels');
  return (
    <Typography className={classes.poweredBy} variant="subtitle1" component="span">
      {t('powered_by')}
      <img className={classes.poweredLogo} src={`${config.rootPath}/white_logo.png`} alt="White logo" />
    </Typography>
  );
}

export default PoweredBy;
